/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface ISelectCcModalScope extends ng.IScope {
        vm: ISelectCcModal;
    }

    interface ISelectCcModal {
        communityColleges: Array<any>;
        commColleges1: Array<any>;
        commColleges2: Array<any>;
        selectedCC: any;
        cancel: () => void;
        ok: () => void;
    }

    class SelectCcModalCtrl implements ISelectCcModal {
        static controllerId: string = "selectCCModalCtrl";
        static $inject: Array<string> = ["common", "$scope", "$uibModalInstance"];
        private log;
        communityColleges: Array<string>;
        commColleges1: Array<string>;
        commColleges2: Array<string>;
        selectedCC: string;
        
        constructor(private common: ICommonFactory, private $scope: ISelectCcModalScope, private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance) {

            var cutOff: number;

            this.log = common.logger.getLogFn(SelectCcModalCtrl.controllerId);
            this.activate();
            this.communityColleges = [
                 "Alamance Community College" ,
                 "Asheville-Buncombe Technical Community College" ,
                 "Beaufort County Community College" ,
                 "Bladen Community College" ,
                 "Blue Ridge Community College" ,
                 "Brunswick Community College" ,
                 "Caldwell Community College and Technical Institute" ,
                 "Cape Fear Community College" ,
                 "Carolinas College of Health Sciences" ,
                 "Carteret Community College" ,
                 "Catawba Valley Community College" ,
                 "Central Carolina Community College" ,
                 "Central Piedmont Community College" ,
                 "Cleveland Community College" ,
                 "Coastal Carolina Community College" ,
                 "College of The Albemarle" ,
                 "Craven Community College" ,
                 "Davidson County Community College" ,
                 "Durham Technical Community College" ,
                 "Edgecombe Community College" ,
                 "Fayetteville Technical Community College" ,
                 "Forsyth Technical Community College" ,
                 "Gaston College" ,
                 "Guilford Technical Community College" ,
                 "Halifax Community College" ,
                 "Haywood Community College" ,
                 "Isothermal Community College" ,
                 "James Sprunt Community College" ,
                 "Johnston Community College" ,
                 "Lenoir Community College" ,
                 "Martin Community College" ,
                 "Mayland Community College" ,
                 "McDowell Technical Community College" ,
                 "Mitchell Community College" ,
                 "Montgomery Community College" ,
                 "Nash Community College" ,
                 "Pamlico Community College" ,
                 "Piedmont Community College" ,
                 "Pitt Community College" ,
                 "Randolph Community College" ,
                 "Richmond Community College" ,
                 "Roanoke-Chowan Community College" ,
                 "Robeson Community College" ,
                 "Rockingham Community College" ,
                 "Rowan-Cabarrus Community College" ,
                 "Sampson Community College" ,
                 "Sandhills Community College" ,
                 "South Piedmont Community College" ,
                 "Southeastern Community College" ,
                 "Southwestern Community College" ,
                 "Stanly Community College" ,
                 "Surry Community College" ,
                 "Tri-County Community College" ,
                 "Vance-Granville Community College" ,
                 "Wake Technical Community College" ,
                 "Warren Wilson College" ,
                 "Wayne Community College" ,
                 "Western Piedmont Community College" ,
                 "Wilkes Community College" ,
                 "Wilson Technical Community College"
            ];
            
            cutOff = (this.communityColleges.length / 2);
            this.commColleges1 = this.communityColleges.slice(0, cutOff);
            this.commColleges2 = this.communityColleges.slice(cutOff);
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, SelectCcModalCtrl.controllerId).then(() => {
                this.log("Activated Modal");
            });
        }

        cancel() {
            this.$uibModalInstance.dismiss('cancel');
        }

        ok() {
            this.$uibModalInstance.close(this.selectedCC);
        }
    }

    angular.module("app").controller(SelectCcModalCtrl.controllerId, SelectCcModalCtrl);
}